import { actionTypes } from './actions';
import initialState from './initialState';

export default function feedbackReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.REQUEST_START:
      return state.set('loading', true).set('error', null);

    case actionTypes.REQUEST_SUCCESS:
      return state.set('loading', false).set('saveSuccess', true);

    case actionTypes.REQUEST_FAILURE:
      return state.set('loading', false).set('error', action.error);

    case actionTypes.OPEN_MODAL:
      return state.set('isOpen', true);

    case actionTypes.CLOSE_MODAL:
      return state.set('isOpen', false);

    case actionTypes.REQUEST_THEMES_START:
      return state.set('loading', true).set('subjects', null);

    case actionTypes.REQUEST_THEMES_SUCCESS:
      return state.set('loading', false).set('subjects', action.payload);

    case actionTypes.REQUEST_THEMES_FAILURE:
      return state.set('loading', false).set('subjects', null).set('error', action.error);

    case actionTypes.RESET:
      return initialState;

    default:
      return state;
  }
}
